/* assets/timeline-slider.js */

class TimelineSlider extends HTMLElement {
  constructor() {
    super();
    this.timelineData = [];
    this.swiperInstance = null;
  }

  connectedCallback() {
    // Use a small delay to ensure Swiper library is loaded if deferred
    // and DOM is ready
    setTimeout(() => {
        this.parseTimelineItems();
        console.log('Timeline Data:', this.timelineData);
        if (this.timelineData && this.timelineData.length > 0) {
            this.renderSliderLayout();
            this.initSwiper();
        } else {
             console.warn('Timeline Slider: No timeline data found to render.');
        }
    }, 100);
  }

  parseTimelineItems() {
    // Assume child elements define the timeline items
    // Example structure: <div data-title="Title 1" data-subtitle="Subtitle 1">
    //                     <h3>Card Title 1</h3><p>Card Body 1</p>
    //                  </div>
    this.timelineData = Array.from(this.children).map(el => {
      // Look for specific elements or data attributes for timeline info
      const cardTitle = el.querySelector('h3')?.innerHTML || '';
      const cardBody = el.querySelector('p')?.innerHTML || '';
      const timelineTitle = el.dataset.timelineTitle || ''; // e.g., "51 BC"
      const timelineSubtitle = el.dataset.timelineSubtitle || ''; // e.g., "5th Century BC - 10th Century CE"

      return {
        cardTitle,
        cardBody,
        timelineTitle,
        timelineSubtitle,
      };
    });
  }

  renderSliderLayout() {
    // Clear existing content (the original data elements)
    while (this.firstChild) {
      this.removeChild(this.firstChild);
    }
    // this.innerHTML = ''; // Keep original elements hidden by CSS instead

    // Create Swiper structure
    const container = document.createElement('div');
    container.className = 'timeline-slider-container';

    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper-wrapper';

    this.timelineData.forEach((item) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide timeline-slide';
      slide.innerHTML = `
        <div class="timeline-card__content">
          <h3>${item.cardTitle}</h3>
          <p>${item.cardBody}</p>
        </div>
        <div class="timeline-connector"></div>
        <div class="timeline-date">
            <span class="timeline-date__title">${item.timelineTitle}</span>
            <span class="timeline-date__subtitle">${item.timelineSubtitle}</span>
        </div>
      `;
      swiperWrapper.appendChild(slide);
    });

    // Add Swiper elements
    const swiperDiv = document.createElement('div');
    swiperDiv.className = 'swiper timeline-slider';
    swiperDiv.appendChild(swiperWrapper);

    // Add Navigation Buttons (optional)
    const nextButton = document.createElement('div');
    nextButton.className = 'swiper-button-next';
    const prevButton = document.createElement('div');
    prevButton.className = 'swiper-button-prev';

    // Add Timeline Axis
    const axis = document.createElement('div');
    axis.className = 'timeline-axis';

    // Append structure to the container
    swiperDiv.appendChild(prevButton);
    swiperDiv.appendChild(nextButton);
    container.appendChild(swiperDiv);
    container.appendChild(axis);

    // Append the container to the custom element
    this.appendChild(container);

    // Add timeline points dynamically based on slide positions after Swiper init
  }

  initSwiper() {
      const swiperEl = this.querySelector('.timeline-slider');
      if (!swiperEl || typeof Swiper === 'undefined') {
        console.error('Swiper container not found or Swiper library not loaded.');
        return;
      }

      console.log('Swiper Initializing with element:', swiperEl);
      this.swiperInstance = new Swiper(swiperEl, {
        // Swiper options
        slidesPerView: 1.5, // Show parts of next/prev slides
        spaceBetween: 20, // Gap between slides
        centeredSlides: false, // Center first slide if true
        grabCursor: true,
        loop: false,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          // Adjust slidesPerView for different screen sizes
          768: {
            slidesPerView: 2.5,
            spaceBetween: 30
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 40
          }
        },
        on: {
            init: () => {
                this.updateTimelinePoints();
            },
            resize: () => {
                 // Add small delay for layout reflow on resize
                setTimeout(() => this.updateTimelinePoints(), 100);
            },
            slideChangeTransitionEnd: () => {
                // Optional: Update points on slide change if needed dynamically
                // this.updateTimelinePoints();
            }
        }
      });
      console.log('Swiper Instance:', this.swiperInstance);
  }

  updateTimelinePoints() {
    const container = this.querySelector('.timeline-slider-container');
    if (!container || !this.swiperInstance) return;

    // Remove existing points
    container.querySelectorAll('.timeline-point').forEach(p => p.remove());

    const slides = this.swiperInstance.slides;
    const axis = this.querySelector('.timeline-axis');
    const containerRect = container.getBoundingClientRect();
    const axisRect = axis.getBoundingClientRect();

    slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        // Calculate the center of the slide relative to the container
        const slideCenterRelative = (slideRect.left - containerRect.left) + (slideRect.width / 2);

        // Create and position the point
        const point = document.createElement('div');
        point.className = 'timeline-point';
        point.style.left = `${slideCenterRelative}px`;
        container.appendChild(point);
    });
  }
}

// Define the custom element
if ('customElements' in window) {
  customElements.define('timeline-slider', TimelineSlider);
} 